import ConstantApi from "../apis/ConstantApi";

/**
 * 作業内容サービスクラス
 */
class ConstantService {
  /**
   * 職場一覧を取得する
   * @memberof ConstantService
   */
  async getWorkPlaces() {
    try {
      return (await new ConstantApi(this).getWorkPlaces()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  /**
   * 機種一覧を取得する
   * @memberof ConstantService
   */
  async getModelTypes() {
    try {
      return (await new ConstantApi(this).getModelTypes()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  /**
   * 機番一覧を取得する
   * @memberof ConstantService
   */
  async getModelNumbers() {
    try {
      return (await new ConstantApi(this).getModelNumbers()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  /**
   * 工程一覧を取得する
   * @memberof ConstantService
   */
  async getWorkProcesses() {
    try {
      return (await new ConstantApi(this).getWorkProcesses()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  /**
   * 停止ロス一覧を取得する
   * @memberof ConstantService
   */
  async getStopLosses() {
    try {
      return (await new ConstantApi(this).getStopLosses()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  /**
   * 間接作業一覧を取得する
   * @memberof ConstantService
   */
  async getIndirectWorks() {
    try {
      return (await new ConstantApi(this).getIndirectWorks()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  /**
   * 無負荷作業一覧を取得する
   * @memberof ConstantService
   */
  async getNoloadWorks() {
    try {
      return (await new ConstantApi(this).getNoloadWorks()).data?.body ?? [];
    } catch (error) {
      console.error(error);
      return [];
    }
  }
}
export const constantService = new ConstantService();
